import React from 'react';
import { Link } from 'react-router-dom';
import { useStoreConfigContext } from '/src/providers';
import * as styles from './styles.scss';

const Breadcrumbs = ({
    isHome = true,
    breadcrumbs,
    name,
    className
}) => {
    const { translate } = useStoreConfigContext();

    return (
        <div className={className}>
            {
                isHome &&
                <Link
                    className={`${styles.home} ${styles.link}`}
                    to="/"
                >
                    {translate('Home')}
                </Link>
            }
            {
                breadcrumbs?.map(({
                    id,
                    name,
                    url,
                }) => (
                    <Link
                        key={id}
                        className={styles.link}
                        to={`/${url}`}
                    >
                        {name}
                    </Link>
                ))
            }
            <span className={styles.name}>{name}</span>
        </div>
    );
};

export default Breadcrumbs;
